<template>
    <v-app>
        <vue-snotify position="top center" ></vue-snotify>
        <Snackbar></Snackbar>
        <v-navigation-drawer
                v-model="drawer"
                v-if="isAuthenticated"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
                dark
                expand-on-hover
                color="primary"
        >
            <v-list dense>
                <v-list>
                    <v-list-item>
                        <v-list-item-avatar size="75">
                            <v-img :src="getProfile.avatar"/>
                        </v-list-item-avatar>
                    </v-list-item>
                    <v-list-item
                            link
                            three-line
                    >
                        <v-list-item-content>
                            <v-list-item-title class="text--white">{{getProfile.role == 6 ? $t('teacher') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 5 ? $t('SuperAdministrador') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 4 ? $t('Administrador') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 3 ? "Tutor" : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 2 ? $t('Vigilante') : ""}}</v-list-item-title>
                            <v-list-item-title class="title">{{getProfile.first_name}} {{getProfile.last_name}}</v-list-item-title>
                            <v-list-item-subtitle>{{getProfile.email}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-menu-down</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <div v-if="getProfile.role === 6">
                    <Teacher></Teacher>
                </div>
                <div v-if="getProfile.role == 5">
                    <SuperAdmin></SuperAdmin>
                </div>
                <div v-if="getProfile.role == 4">
                    <Admin></Admin>
                </div>
                <div v-if="getProfile.role == 3">
                    <Tutor></Tutor>
                </div>
                <div v-if="getProfile.role == 2">
                    <Guard></Guard>
                </div>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="primary"
                dark
        >
            <v-app-bar-nav-icon v-if="isAuthenticated" @click.stop="drawer = !drawer" />
            <router-link :to="{ name: 'home'}" class="text">
                    <v-avatar>
                        <v-img :src="require('../src/assets/logo.png')"/>
                    </v-avatar>
            </router-link>
            <template v-slot:extension v-if="getProfile.logo">
                <v-btn
                        fab
                        color="white"
                        bottom
                        right
                        x-large
                        absolute
                        @click="dialog = !dialog"
                >
                    <v-avatar>
                        <v-img :src="getProfile.logo"></v-img>
                    </v-avatar>
                </v-btn>
            </template>
            <v-toolbar-title
                    dark
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <span>
                    <strong>
                        <router-link :to="{ name: 'home'}" class="text">
                            {{$t('intrare_escuelas')}}
                        </router-link>
                    </strong>
                </span>
            </v-toolbar-title>
            <v-spacer />
            <h5 v-show="guardhouseName !== null">{{(getProfile.role === 2 && guardhouseName !== null)? "Caseta: " + guardhouseName : ""}}</h5>
            <v-btn
                    icon
                    large
                    @click="setLocale('es')"
            >
                <v-avatar
                        size="32px"
                        item
                >
                    <div style="font-size:25px">
                        <flag iso="mx">
                        </flag>
                    </div>
                </v-avatar>
            </v-btn>
            <v-btn
                    icon
                    large
                    @click="setLocale('en')"
            >
                <v-avatar
                        size="32px"
                        item
                >
                    <div style="font-size:25px">
                        <flag iso="us">
                        </flag>
                    </div>
                </v-avatar>
            </v-btn>
            <v-btn icon v-if="isAuthenticated" @click="logout()">
                <v-icon>mdi-account-arrow-right</v-icon>
            </v-btn>
        </v-app-bar>
        <v-content>
            <v-container
                    class="fill-height"
                    fluid
            >
                <router-view/>
            </v-container>
        </v-content>
        <footer>
            <Foot/>
        </footer>
    </v-app>
</template>

<script>
import Foot from './components/Foot.vue'
import { USER_REQUEST } from '@/store/actions/user'
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from './store/actions/auth'
import SuperAdmin from '@/components/Menu/super_admin.vue'
import Admin from '@/components/Menu/admin.vue'
import Teacher from '@/components/Menu/teacher.vue'
import Tutor from '@/components/Menu/tutor.vue'
import Guard from '@/components/Menu/guard.vue'
import Snackbar from '@/components/snackbar.vue'
import { extend, localize } from 'vee-validate'
import { required, image } from 'vee-validate/dist/rules'
import {HTTP} from '@/main.js'
import store from '@/store'

extend('required', required)
extend('image', image)

// Install English and Spanish localizations.
localize({
  es: {
    messages: {
      required: 'Este campo es Obligatorio',
      image: 'Este campo debe ser una Imagen'
    }
  },
  en: {
    messages: {
      required: 'This field is required',
      image: 'The field must be an image'
    }
  }
})

export default {
  name: 'App',
  components: {
    Snackbar,
    Foot,
    SuperAdmin,
    Admin,
    Teacher,
    Tutor,
    Guard,
  },
  data: () => ({
    drawer: null,
    bandOnline: true,
    listaEstudiantesLocal: [],
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'getProfile']),
    ...mapState(['qrDevices', 'guardhouseName'])
  },
  created: function () {
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
      console.log('Conecta....')
      console.log('Data User 1 = ', JSON.parse(localStorage.getItem('userData')).id)
      switch (JSON.parse(localStorage.getItem('userData')).role) {
        case 2:  // Vigilante
          this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + localStorage.getItem('idGuardHouse') + '/?token=' +  localStorage.getItem('user-token'))
          if(localStorage.getItem('listaEstudiantes') !== null) {
            this.listaEstudiantesLocal = JSON.parse(localStorage.getItem('listaEstudiantes'))
          }
        break;
        case 4: // Administrador
          this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + localStorage.getItem('idSchool') + '/?token=' +  localStorage.getItem('user-token'))
        break;
        case 6: // Maestro
            this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + JSON.parse(localStorage.getItem('userData')).id + '/?token=' +  localStorage.getItem('user-token'))
        break;
      }
      console.log('Conectado')
    }
  },
  beforeCreate() {
    this.$options.sockets = {
      onmessage: data => this.messageReceived(data)
    }
  },
  methods: {
      messageReceived(data) {
        console.log('Datoooos Recividos: ', data.type)
        console.log('Parseados ', JSON.parse(data.data).message)
        let type = JSON.parse(JSON.parse(data.data).message)
        switch (JSON.parse(localStorage.getItem('userData')).role) {
          case 2: // Vigilante
            if (type.classification) { // Si la informacion se escaneo desde totem
              let qr_code = type.data
              switch (type.classification) {
                case 'qr':
                  console.log('QR Code')
                  if (qr_code !== '') {
                    HTTP.get('student/access_code/' + qr_code + '/' + localStorage.getItem('idGuardHouse'), {
                      headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                      }
                    })
                        .then(response => {
                          // console.log(this.info_invitation.students[0].avatar)
                          var item = response.data
                          var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
                          item.available_students = studentfiltered
                          var fullItem = Object.assign(item, {"qrCode": qr_code})
                          console.log(fullItem)
                          if(item.available_students.length > 0) {
                            this.addListItem(fullItem)
                            this.sendNotificationToTeachers(item, type.guardhouse_name)
                            // localStorage.setItem('listaEstudiantes', JSON.stringify(this.listaEstudiantesLocal))
                            // this.$socket.send(JSON.stringify({
                            //   "message": JSON.stringify(this.listaEstudiantesLocal)
                            // }))
                          }
                        })
                        .catch(error => {
                          console.log(error)
                        })
                  }
                  break
                case 'cam':
                  var aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
                  aux.push(type.data)
                  localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
                  this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
                  if (localStorage.getItem('cam_devices') !== null) {
                    console.log('Dato recivido de CAM')
                    let band = false
                    let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                    console.log('Auxiluar = ', devicesAux)
                    for (let i = 0; !band && i < devicesAux.length; i++) {
                      if (devicesAux[i].label === type.label) {
                        console.log(devicesAux[i].label, '===', type.label)
                        devicesAux[i] = Object.assign(devicesAux[i], { 'data': type.data })
                        localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                        this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                        band = true
                      }
                    }
                    console.log(JSON.parse(localStorage.getItem('cam_devices')))
                  }
                  break
              }
            } else { // Si la informacion es entre sesiones de vigilantes
              // Obtener datos de los Tutores/Invitados y Estudiantes
              // localStorage.setItem('listaEstudiantes', JSON.parse(data.data).message)
              // this.$store.commit('setStudentsList', JSON.parse(data.data).message)
              this.getQrCodes()
            }
          break;
          case 4: // Administrador
            if (type.classification) {
              switch (type.classification) {
                case 'rfid':
                   this.$store.commit('setRFID', type.data)
                break;
              }
            }
          break;
          case 6: // Maestro
            var datos = JSON.parse(JSON.parse(data.data).message)
            console.log('Datos = ', datos)
            this.$snotify.confirm(datos.body + ', ' + datos.classroom + '. Salida por: ' + datos.guardhouse_name, '', {
              timeout: 0,
              closeOnClick: false,
              type: 'info',
              newOnTop: true,
              buttons: [
                {
                  text: this.$t('sign'),
                  action: (toast) => {
                    this.$snotify.remove(toast.id);
                    this.signExitPass(datos.uuidStudent, datos.uuidClassroom);
                  },
                  bold: false
                }
              ]
            })
          break;
        }
      },
    getQrCodes () {
      HTTP.get('checkout_list/' + localStorage.getItem('idGuardHouse') + '/',
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + localStorage.getItem('user-token')
          }
        })
        .then(response => {
          this.getCheckOutList(response.data)
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCheckOutList (list) {
      let qr_codes_aux = []

      for(let i = 0; i< list.length; i++) {
        qr_codes_aux.push({
          'qr_code': list[i].qr_code
        })
      }
      HTTP.post('students/access_code/filter/' + localStorage.getItem('idGuardHouse'), {
          qr_codes: qr_codes_aux
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
      .then(response => {
        localStorage.setItem('listaEstudiantes', JSON.stringify(response.data))
        this.$store.commit('setStudentsList', JSON.stringify(response.data))
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
    },
    setLocale(aLanguage){
      localize(aLanguage)
      this.$i18n.locale = aLanguage
      this.$store.commit('changeLanguage', aLanguage)
    },
    logout () {
      localStorage.removeItem('id_caseta')
      localStorage.removeItem('idSchool')
      localStorage.removeItem('userData')
      localStorage.removeItem('idGuardHouse')
      localStorage.removeItem('gradesGuardHouse')
      localStorage.removeItem('guardhouse_name')
      this.$store.commit('setGuardhouseName', null)
      localStorage.removeItem('qr_devices')
      localStorage.removeItem('banderaQR')
      // delete this.$options.sockets.onmessage
      this.$disconnect()
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
    },
    addListItem(item) {
      let band = false

      for(let i = 0 ; !band && i < this.listaEstudiantesLocal.length; i++) {
        console.log(this.listaEstudiantesLocal[i].qrCode, '===', item.qrCode)
        if(this.listaEstudiantesLocal[i].qrCode === item.qrCode){
          band = true
        }
      }
      if (!band) {
        this.listaEstudiantesLocal.push(item)
        // Agregar registro a la Base de Datos
        this.addQRCodeToDB(item.qrCode)
        this.$socket.send(JSON.stringify( {
          "message":  JSON.stringify('addRecord')
        }))
      }
      console.log(this.listaEstudiantesLocal)
    },
    deleteStudentNoAttendance(item) {
      let res = []
      console.log(item)
      for (let i=0; i < item.length; i++) {
        if(item[i].status !== -1) {
          console.log(item[i].status)
          res.push(item[i])
        }
      }
      return res
    },
    addQRCodeToDB (aQRCode) {
      HTTP.post('checkout_list/',
        {
          idSchool: localStorage.getItem('idSchool'),
          idGuardhouse: localStorage.getItem('idGuardHouse'),
          qr_code: aQRCode
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + localStorage.getItem('user-token')
          }
        })
        .then(ok => {
          console.log(ok)
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendNotificationToTeachers (data, name) {
      for(let i = 0; i < data.available_students.length; i++) {
        if (data.available_students[i].status !== -1) {
          HTTP.post('student/' + data.available_students[i].id + '/exit/notification/',
            {
                guardhouse_name: name
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
                'authorization': 'Token ' + store.getters.getToken
              }
          })
          .then(ok => {
            console.log(ok)
          })
          .catch(error => {
            console.log(error)
          })
        }
        setTimeout(this.clearTime, 100)
      }
    },
    clearTime () {
      console.log('Time...')
    },
    signExitPass(uuidStudent, uuidClassroom) {
      var student = []

      student.push({
        'idStudent': uuidStudent
      })
      HTTP.patch('classroom/' + uuidClassroom + '/list/sign_pass/',
        student,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + localStorage.getItem('user-token')
        }
      })
      .then(ok => {
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('sign_pass_success'))
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        console.log(error)
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped lang="scss">
    @import '~vue-snotify/styles/material.css';
    $primary-color: #fff;
    $font-stack: Roboto, sans-serif;
    .text {
        font: $font-stack;
        color: white;
        text-decoration:none;
    }
    .text:hover {
        font: $font-stack;
        color: white;
        text-decoration:none;
    }
</style>
